var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnaSayfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    fill: "url(#paint0_linear_1686_738)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 8.25C7.5 7.83579 7.83579 7.5 8.25 7.5H13.5C13.9142 7.5 14.25 7.83579 14.25 8.25V13.5C14.25 13.9142 13.9142 14.25 13.5 14.25H8.25C7.83579 14.25 7.5 13.9142 7.5 13.5V8.25ZM9 9V12.75H12.75V9H9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 8.25C15.75 7.83579 16.0858 7.5 16.5 7.5H21.75C22.1642 7.5 22.5 7.83579 22.5 8.25V13.5C22.5 13.9142 22.1642 14.25 21.75 14.25H16.5C16.0858 14.25 15.75 13.9142 15.75 13.5V8.25ZM17.25 9V12.75H21V9H17.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 16.5C15.75 16.0858 16.0858 15.75 16.5 15.75H21.75C22.1642 15.75 22.5 16.0858 22.5 16.5V21.75C22.5 22.1642 22.1642 22.5 21.75 22.5H16.5C16.0858 22.5 15.75 22.1642 15.75 21.75V16.5ZM17.25 17.25V21H21V17.25H17.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 16.5C7.5 16.0858 7.83579 15.75 8.25 15.75H13.5C13.9142 15.75 14.25 16.0858 14.25 16.5V21.75C14.25 22.1642 13.9142 22.5 13.5 22.5H8.25C7.83579 22.5 7.5 22.1642 7.5 21.75V16.5ZM9 17.25V21H12.75V17.25H9Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1686_738",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnaSayfa);
export default __webpack_public_path__ + "static/media/ana-sayfa.f7f895af0b32cbe22b73fb66c861c96e.svg";
export { ForwardRef as ReactComponent };